import { gql } from '@apollo/client';

export const SendMessageToDriver = gql`
  mutation SendMessageToDriver($gigId: ID!, $templateId: ID!, $textlineGroupUuid: String!) {
    sendMessageToDriver(gigId: $gigId, templateId: $templateId, textlineGroupUuid: $textlineGroupUuid) {
      ok
    }
  }
`;
